
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.268 4.675c-.466-.826-.7-1.238-.563-1.614.137-.375.577-.53 1.458-.843l.75-.265c.538-.191.807-.286 1.087-.286.28 0 .549.095 1.088.286l.75.265c.88.312 1.32.468 1.457.843.136.376-.097.788-.563 1.614l-.43.761c-.22.391-.33.586-.524.74-.193.153-.372.204-.73.306-.342.098-.733.185-1.048.185-.315 0-.706-.087-1.048-.185-.358-.102-.537-.153-.73-.306-.193-.154-.304-.349-.524-.74l-.43-.761zM8.4 6.667L7.016 12.62c-.3 1.29-.45 1.936-.278 2.543l.01.036c.18.604.652 1.065 1.594 1.987.777.761 1.166 1.142 1.643 1.147h.028c.477-.005.866-.386 1.643-1.146.943-.923 1.414-1.384 1.594-1.988l.01-.036c.171-.607.022-1.252-.278-2.543L11.6 6.667","stroke":"#fff","stroke-width":"1.5"}})])
          )
        }
      }
    